<template>
  <div class="program-schedule-page">
    <!-- Notification Snackbar -->
    <v-snackbar
      v-model="snackbar"
      :color="snackbarColor"
      :timeout="4000"
      top
      right
      elevation="24"
      class="custom-snackbar"
    >
      <div class="snackbar-content">
        <v-icon color="white" class="mr-3" size="28">{{ snackbarIcon }}</v-icon>
        <div>
          <div class="snackbar-title">{{ snackbarTitle }}</div>
          <div class="snackbar-message">{{ snackbarMessage }}</div>
        </div>
      </div>
      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="snackbar = false"
          icon
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>

    <!-- Hero Banner -->
    <div class="hero-banner">
      <div class="banner-overlay"></div>
      <v-container class="hero-content">
        <div class="hero-icon-wrapper">
          <v-icon color="white" size="40">mdi-calendar-clock</v-icon>
        </div>
        <h1 class="hero-title">Program Schedule</h1>
        <p class="hero-subtitle">View all program schedules and zone timings</p>
      </v-container>
    </div>

    <!-- Main Content -->
    <v-container class="content-container">
      <v-row justify="center">
        <v-col cols="12">

          <!-- Zone 1 Schedule Card -->
          <v-card class="schedule-image-card mb-4" elevation="12">
            <div class="card-header">
              <v-icon color="white" class="mr-2" size="20">mdi-calendar-clock</v-icon>
              <span class="card-header-title">Zone 1 Schedule</span>
              <v-spacer></v-spacer>
              <div v-if="loggedInUser === 'SuperAdmin' || loggedInUser === 'Admin'" class="zone-control">
                <v-chip
                  :color="showZone1 ? 'success' : 'error'"
                  dark
                  small
                  class="status-chip mr-2"
                >
                  <v-icon small left>{{ showZone1 ? 'mdi-eye' : 'mdi-eye-off' }}</v-icon>
                  {{ showZone1 ? 'Visible' : 'Hidden' }}
                </v-chip>
                <v-btn
                  :color="showZone1 ? 'error' : 'success'"
                  small
                  dark
                  elevation="2"
                  class="control-btn"
                  @click="toggleZone('showZone1', 'Zone1', !showZone1)"
                >
                  <v-icon small left>{{ showZone1 ? 'mdi-close-circle' : 'mdi-check-circle' }}</v-icon>
                  {{ showZone1 ? 'Hide' : 'Show' }}
                </v-btn>
              </div>
            </div>

            <v-card-text v-if="showZone1" class="pa-0" style="overflow-x: auto;">
              <v-img
                src="@/assets/zone1schedule.png"
                alt="Zone 1 Program Schedule"
                contain
                min-width="100%"
              ></v-img>
            </v-card-text>
          </v-card>

          <!-- Zone 2 Schedule Card -->
          <v-card class="schedule-image-card mb-4" elevation="12">
            <div class="card-header">
              <v-icon color="white" class="mr-2" size="20">mdi-calendar-clock</v-icon>
              <span class="card-header-title">Zone 2 Schedule (7.30 AM)</span>
              <v-spacer></v-spacer>
              <div v-if="loggedInUser === 'SuperAdmin' || loggedInUser === 'Admin'" class="zone-control">
                <v-chip
                  :color="showZone2 ? 'success' : 'error'"
                  dark
                  small
                  class="status-chip mr-2"
                >
                  <v-icon small left>{{ showZone2 ? 'mdi-eye' : 'mdi-eye-off' }}</v-icon>
                  {{ showZone2 ? 'Visible' : 'Hidden' }}
                </v-chip>
                <v-btn
                  :color="showZone2 ? 'error' : 'success'"
                  small
                  dark
                  elevation="2"
                  class="control-btn"
                  @click="toggleZone('showZone2', 'Zone2', !showZone2)"
                >
                  <v-icon small left>{{ showZone2 ? 'mdi-close-circle' : 'mdi-check-circle' }}</v-icon>
                  {{ showZone2 ? 'Hide' : 'Show' }}
                </v-btn>
              </div>
            </div>

            <v-card-text v-if="showZone2" class="pa-0" style="overflow-x: auto;">
              <v-img
                src="@/assets/zone2schedule.png"
                alt="Zone 2 Program Schedule"
                contain
                min-width="100%"
              ></v-img>
            </v-card-text>
          </v-card>

          <!-- Zone 3 Schedule Card -->
          <v-card class="schedule-image-card mb-4" elevation="12">
            <div class="card-header">
              <v-icon color="white" class="mr-2" size="20">mdi-calendar-clock</v-icon>
              <span class="card-header-title">Zone 3 Schedule (9.30 AM)</span>
              <v-spacer></v-spacer>
              <div v-if="loggedInUser === 'SuperAdmin' || loggedInUser === 'Admin'" class="zone-control">
                <v-chip
                  :color="showZone3 ? 'success' : 'error'"
                  dark
                  small
                  class="status-chip mr-2"
                >
                  <v-icon small left>{{ showZone3 ? 'mdi-eye' : 'mdi-eye-off' }}</v-icon>
                  {{ showZone3 ? 'Visible' : 'Hidden' }}
                </v-chip>
                <v-btn
                  :color="showZone3 ? 'error' : 'success'"
                  small
                  dark
                  elevation="2"
                  class="control-btn"
                  @click="toggleZone('showZone3', 'Zone3', !showZone3)"
                >
                  <v-icon small left>{{ showZone3 ? 'mdi-close-circle' : 'mdi-check-circle' }}</v-icon>
                  {{ showZone3 ? 'Hide' : 'Show' }}
                </v-btn>
              </div>
            </div>

            <v-card-text v-if="showZone3" class="pa-0" style="overflow-x: auto;">
              <v-img
                src="@/assets/zone3schedule.png"
                alt="Zone 3 Program Schedule"
                contain
                min-width="100%"
              ></v-img>
            </v-card-text>
          </v-card>

       <!--    Zone 4 Schedule Card
          <v-card class="schedule-image-card" elevation="12">
            <div class="card-header">
              <v-icon color="white" class="mr-2" size="20">mdi-calendar-clock</v-icon>
              <span class="card-header-title">Zone 4 Schedule (11.30 AM)</span>
              <v-spacer></v-spacer>
              <div v-if="loggedInUser === 'SuperAdmin' || loggedInUser === 'Admin'" class="zone-control">
                <v-chip
                  :color="showZone4 ? 'success' : 'error'"
                  dark
                  small
                  class="status-chip mr-2"
                >
                  <v-icon small left>{{ showZone4 ? 'mdi-eye' : 'mdi-eye-off' }}</v-icon>
                  {{ showZone4 ? 'Visible' : 'Hidden' }}
                </v-chip>
                <v-btn
                  :color="showZone4 ? 'error' : 'success'"
                  small
                  dark
                  elevation="2"
                  class="control-btn"
                  @click="toggleZone('showZone4', 'Zone4', !showZone4)"
                >
                  <v-icon small left>{{ showZone4 ? 'mdi-close-circle' : 'mdi-check-circle' }}</v-icon>
                  {{ showZone4 ? 'Hide' : 'Show' }}
                </v-btn>
              </div>
            </div>

            <v-card-text v-if="showZone4" class="pa-0" style="overflow-x: auto;">
              <v-img
                src="@/assets/zone4schedule.png"
                alt="Zone 4 Program Schedule"
                contain
                min-width="100%"
              ></v-img>
            </v-card-text>
          </v-card>
 -->
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import ReportServices from "@/services/ReportServices";

export default {
  name: 'ProgramSchedule',
  data() {
    return {
      showZone1: false,
      showZone2: false,
      showZone3: false,
      showZone4: false,
      loading: true,
      isInitialLoad: true,
      snackbar: false,
      snackbarColor: 'success',
      snackbarIcon: 'mdi-check-circle',
      snackbarTitle: '',
      snackbarMessage: ''
    }
  },
  computed: {
    loggedInUser() {
      var user = this.$store.getters.email;
      var role = this.$store.getters.role;
      if (user && role === "SuperAdmin") return "SuperAdmin";
      else if (user && role === "Admin") return "Admin";
      else if (user && role === "Member") return "Member";
      else return null;
    }
  },
  methods: {
    async loadZoneSwitches() {
      try {
        this.loading = true;
        this.isInitialLoad = true;

        // Load Zone 1 switch status
        const zone1Response = await ReportServices.getZoneSwitch('Zone1');
        this.showZone1 = (zone1Response.data && zone1Response.data.Switch === 'On');

        // Load Zone 2 switch status
        const zone2Response = await ReportServices.getZoneSwitch('Zone2');
        this.showZone2 = (zone2Response.data && zone2Response.data.Switch === 'On');

        // Load Zone 3 switch status
        const zone3Response = await ReportServices.getZoneSwitch('Zone3');
        this.showZone3 = (zone3Response.data && zone3Response.data.Switch === 'On');

        // Load Zone 4 switch status
        const zone4Response = await ReportServices.getZoneSwitch('Zone4');
        this.showZone4 = (zone4Response.data && zone4Response.data.Switch === 'On');

        this.loading = false;
        this.isInitialLoad = false;
      } catch (error) {
        // Set default values if API fails
        this.showZone1 = true;
        this.showZone2 = false;
        this.showZone3 = false;
        this.showZone4 = false;
        this.loading = false;
        this.isInitialLoad = false;
      }
    },

    async toggleZone(zoneKey, zoneName, newValue) {
      if (this.loggedInUser === 'SuperAdmin' || this.loggedInUser === 'Admin') {
        // Apply the change immediately
        this[zoneKey] = newValue;

        // Call API to update
        try {
          await ReportServices.updateZoneSwitch({
            ZoneDetails: zoneName,
            Switch: newValue ? 'On' : 'Off'
          });

          // Show success notification
          this.showNotification(
            'success',
            'mdi-check-circle',
            'Zone Updated Successfully',
            zoneName + ' is now ' + (newValue ? 'Visible' : 'Hidden')
          );
        } catch (error) {
          // Revert the change on error
          this[zoneKey] = !newValue;

          // Show error notification
          this.showNotification(
            'error',
            'mdi-alert-circle',
            'Update Failed',
            'Failed to update ' + zoneName + '. Please try again.'
          );
        }
      }
    },

    showNotification(color, icon, title, message) {
      this.snackbarColor = color;
      this.snackbarIcon = icon;
      this.snackbarTitle = title;
      this.snackbarMessage = message;
      this.snackbar = true;
    }
  },
  async mounted() {
    await this.loadZoneSwitches();
  }
}
</script>

<style scoped>
.program-schedule-page {
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

/* Hero Banner */
.hero-banner {
  position: relative;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 20px 0 15px 0;
  overflow: hidden;
}

.banner-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.2);
}

.hero-content {
  position: relative;
  z-index: 1;
  text-align: center;
}

.hero-icon-wrapper {
  margin-bottom: 8px;
  animation: float 3s ease-in-out infinite;
}

@keyframes float {
  0%, 100% { transform: translateY(0px); }
  50% { transform: translateY(-10px); }
}

.hero-title {
  color: white;
  font-size: 1.75rem;
  font-weight: 700;
  margin-bottom: 5px;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
}

.hero-subtitle {
  color: rgba(255, 255, 255, 0.95);
  font-size: 0.95rem;
  margin: 0;
}

/* Content Container */
.content-container {
  padding: 15px 12px;
  max-width: 1200px;
}

/* Schedule Card */
.schedule-image-card {
  border-radius: 8px !important;
  overflow: hidden;
  background: white;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
}

.card-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 12px 16px;
  display: flex;
  align-items: center;
  color: white;
}

.card-header-title {
  font-size: 1.1rem;
  font-weight: 600;
}

/* Zone Control Buttons */
.zone-control {
  display: flex;
  align-items: center;
  gap: 8px;
}

.status-chip {
  font-weight: 600;
  letter-spacing: 0.5px;
  animation: chipFade 0.3s ease-in;
}

@keyframes chipFade {
  from { opacity: 0; transform: scale(0.9); }
  to { opacity: 1; transform: scale(1); }
}

.control-btn {
  text-transform: none;
  font-weight: 700;
  letter-spacing: 0.5px;
  transition: all 0.3s ease;
}

.control-btn:hover {
  transform: scale(1.05);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3) !important;
}

/* Snackbar Notification Styles */
.custom-snackbar {
  margin-top: 60px;
}

.snackbar-content {
  display: flex;
  align-items: center;
}

.snackbar-title {
  font-size: 1rem;
  font-weight: 700;
  color: white;
  margin-bottom: 4px;
  letter-spacing: 0.5px;
}

.snackbar-message {
  font-size: 0.9rem;
  color: rgba(255, 255, 255, 0.95);
  font-weight: 500;
}

/* Mobile Responsive */
@media (max-width: 960px) {
  .hero-banner {
    padding: 15px 0 12px 0;
  }

  .hero-title {
    font-size: 1.5rem;
  }

  .hero-subtitle {
    font-size: 0.9rem;
  }

  .content-container {
    padding: 12px 10px;
  }

  .card-header {
    padding: 10px 14px;
  }

  .card-header-title {
    font-size: 1rem;
  }

  .zone-control {
    flex-wrap: wrap;
    gap: 6px;
  }

  .status-chip {
    font-size: 0.7rem;
  }

  .control-btn {
    font-size: 0.75rem;
  }

  .snackbar-title {
    font-size: 0.9rem;
  }

  .snackbar-message {
    font-size: 0.8rem;
  }
}

@media (max-width: 600px) {
  .hero-banner {
    padding: 12px 0 10px 0;
  }

  .hero-title {
    font-size: 1.3rem;
  }

  .hero-subtitle {
    font-size: 0.85rem;
  }

  .hero-icon-wrapper v-icon {
    font-size: 40px !important;
  }

  .content-container {
    padding: 10px 8px;
  }

  .card-header {
    padding: 8px 12px;
  }

  .card-header-title {
    font-size: 0.95rem;
  }
}

@media (max-width: 400px) {
  .hero-title {
    font-size: 1.2rem;
  }

  .hero-subtitle {
    font-size: 0.8rem;
  }

  .card-header {
    padding: 8px 10px;
  }

  .card-header-title {
    font-size: 0.9rem;
  }
}
</style>
